<template>
  <div class="container">
    <div class="content flex">
      <a-input class="search-input" v-model="keyWord" @keyup.enter.native="getList" /><a-button type="primary" class="search-btn" @click="getList"
        >搜索</a-button
      >
    </div>
    <div class="table-div">
      <a-table class="table" :loading="loading" :columns="columns" :data-source="data" :pagination="false"></a-table>
      <div><a-button type="link" @click="feedbackVisible = true" class="feedback-button">点我反馈，您的反馈可以更好的帮助我们优化流程</a-button></div>
    </div>
    <feedback v-model="feedbackVisible" type="humit"></feedback>
  </div>
</template>

<script lang="js">
import Vue from 'vue';
import request from '@/assets/js/http';
import Feedback from '@/components/base/feedback.vue';
import { queryByName } from '@/api/humint.js';

const columns = [
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '简介',
    dataIndex: 'info',
    key: 'info'
  },
  {
    title: '负责人',
    dataIndex: 'director',
    key: 'director'
  },
  {
    title: '来源',
    dataIndex: 'source',
    key: 'source'
  },
  {
    title: '数据源',
    dataIndex: 'origin',
    key: 'origin'

  }
];

export default Vue.extend({
  name: 'KPSearch',
  components: {
    Feedback
  },
  data() {
    return {
      columns: columns,
      data: [],
      keyWord: '',
      loading: false,
      feedbackVisible: false
    };
  },
  methods: {
    async getList() {

      if (this.keyWord === '') {
        this.$message.error('请输入人名');
        return;
      }
      if(this.loading) {
        return;
      }
      this.loading = true;
      this.data = [];
      let data = { name: this.keyWord };
      await Promise.all([
        request({
          url: '/kpSeed/list',
          method: 'post',
          data
        }).then(res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              this.data.push({...item, origin: 'seed-KP池'});
            });
          }
        }).catch(err => {
          console.log(err);
        }),
        queryByName(this.keyWord).then(res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              this.data.push({
                name: item.userName,
                info: item.info,
                director: item.contacts,
                origin: item.origin
              });
            });
          }
        }).catch(err => {
          console.log(err);
        })
      ]).finally(() => {
        this.loading = false;
      });

    }
  },
  mounted() {
    // this.getList();
  }
});
</script>

<style lang="less" scoped>
.table-div {
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.feedback-button {
  color: #999;
}
@media only screen and (max-width: 800px) {
  .container {
    padding: 20px;
    .table-div {
      padding-top: 20px;
      .table {
        width: 100%;
      }
    }

    .search-btn {
      margin-left: 12px;
    }
  }
}
@media only screen and (min-width: 800px) {
  .container {
    padding-top: 100px;
    .content {
      justify-content: center;
      .search-input {
        width: 40%;
      }
      .search-btn {
        margin-left: 24px;
      }
    }
    .table-div {
      padding-top: 32px;
      .table {
        width: 60%;
      }
    }
  }
}

.flex {
  display: flex;
}
</style>
